import axios from "@axios"

let coursesEndpoint = '/courses'
let restoreCourseEndpoint = '/courses/restore'
// let destroyCourseEndpoint = '/courses/hardDelete'

/**
 * ÍNDICE
 * 
 * {@link getCourses} - Obtener cursos
 * {@link getTrashedCourses} - Obtener cursos eliminados
 * {@link restoreCourse} - Restaurar curso
 * {@link destroyCourse} - Eliminar curso (No habilitado)
 */

/**
 * Obtener todos los cursos
 * @param {*} data Datos para filtrar la consulta
 * @returns courses | error
 */
export const getCourses = function(data) {
    try {
        return new Promise((resolve, reject) => {            
            axios.get(coursesEndpoint, { params: data  })
            .then(response => { return resolve(response.data.courses) })
            .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

/**
 * Obtener los cursos eliminados
 * @returns trashedCourses | error
 */
export const getTrashedCourses = function() {
    try {
        return new Promise((resolve, reject) => {
            axios.get(coursesEndpoint, { params: { trashed: true } })
            .then(response => { return resolve(response.data.courses) })
            .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

/**
 * Restaurar un curso borrado
 * @param {integer} id ID del curso
 * @returns boolean
 */
export const restoreCourse = function(id) {
    try {
        return new Promise((resolve, reject) => {
            axios.post(restoreCourseEndpoint, { id: id  })
            .then(response => { return resolve(response.data) })
            .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

/**
 * Eliminar de base de datos a un curso
 * @param {integer} id ID del curso a eliminar 
 * @returns boolean
 */
// export const destroyCourse = function(id) {
//     try {
//         return new Promise((resolve, reject) => {
//             axios.get(destroyCourseEndpoint, { id: id })
//             .then(response => { return resolve(response.data) })
//             .catch(error => { return reject(error) })
//         })
//     } catch (error) {
//         return error
//     }
// }